import { render, staticRenderFns } from "./SettingPointModal.vue?vue&type=template&id=48dc2b3f&scoped=true&"
import script from "./SettingPointModal.vue?vue&type=script&lang=js&"
export * from "./SettingPointModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingPointModal.vue?vue&type=style&index=0&id=48dc2b3f&scoped=true&lang=css&"
import style1 from "./SettingPointModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dc2b3f",
  null
  
)

export default component.exports